var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuVouchersActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-Framework",
    transform: "translate(-366.000000, -362.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9-Copy-2",
    transform: "translate(366.000000, 359.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Menu_Vouchers_Active",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,4 L11.816,4 C11.928,3.686 12,3.353 12,3 C12,1.343 10.657,0 9,0 C8.229,0 7.531,0.3 7,0.778 C6.469,0.3 5.771,0 5,0 C3.343,0 2,1.343 2,3 C2,3.353 2.072,3.686 2.184,4 L1,4 C0.447,4 0,4.447 0,5 L0,15 C0,15.5530005 0.447,16 1,16 L13,16 C13.553,16 14,15.5530005 14,15 L14,5 C14,4.447 13.553,4 13,4 Z M6,4 L5,4 C4.447,4 4,3.553 4,3 C4,2.447 4.447,2 5,2 C5.553,2 6,2.447 6,3 L6,4 Z M8,3 C8,2.447 8.447,2 9,2 C9.553,2 10,2.447 10,3 C10,3.553 9.553,4 9,4 L8,4 L8,3 Z",
    id: "Fill-1",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "6 14 2 14 2 6 6 6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "12 14 8 14 8 6 12 6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuVouchersActive);
export default __webpack_public_path__ + "static/media/Icon-Menu_Vouchers_Active.7d14da74b3b1f97c0d4bd23ce483eb37.svg";
export { ForwardRef as ReactComponent };